import { BaseProps, SaveCartProps } from '@vsf-enterprise/sapcc-api';
import { Cart } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { Context } from '@vue-storefront/core';

export async function cloneCart(
  context: Context,
  params: BaseProps,
  cart: Cart
): Promise<Cart> {
  const props: SaveCartProps = { ...params, cartId: cart.code };

  const savedCart = await context.$sapcc.api.cloneCart(props);

  return savedCart;
}
